export default "__VITE_ASSET__DmDd_oGR__"